<span [style]="style">{{ text }}</span>
